import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=771b151b&scoped=true&"
import script from "./CompanyList.vue?vue&type=script&lang=js&"
export * from "./CompanyList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=771b151b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b151b",
  null
  
)

export default component.exports